/** Headers for office API calls. Production relies on Cloudflare Access; local dev uses x-user-email. */
export function apiRequestHeaders(contentJson = false): HeadersInit {
  const headers: Record<string, string> = {};
  if (contentJson) headers["content-type"] = "application/json";
  const devEmail = import.meta.env.VITE_DEV_USER_EMAIL as string | undefined;
  if (import.meta.env.DEV && devEmail) {
    headers["x-user-email"] = devEmail;
  }
  return headers;
}
